import React from 'react';

/**
 * HC Logo inside a blue rounded square brand mark.
 * Props:
 *  - size: tailwind size preset (sm=7, md=8, lg=11) or number (px)
 *  - className: additional classes for outer div
 */
const SIZE_MAP = {
  sm: { box: 'w-7 h-7', rounded: 'rounded-lg', padding: 'p-1' },
  md: { box: 'w-8 h-8', rounded: 'rounded-lg', padding: 'p-1' },
  lg: { box: 'w-10 h-10', rounded: 'rounded-xl', padding: 'p-1.5' },
  xl: { box: 'w-11 h-11', rounded: 'rounded-xl', padding: 'p-1.5' }
};

const HCLogo = ({ size = 'md', className = '', bgClass = 'bg-blue-700' }) => {
  const cfg = SIZE_MAP[size] || SIZE_MAP.md;
  return (
    <div className={`${cfg.box} ${cfg.rounded} ${bgClass} flex items-center justify-center flex-shrink-0 shadow-sm ${cfg.padding} ${className}`}>
      <img
        src="/hc-logo.png"
        alt="HC"
        className="w-full h-full object-contain"
        draggable={false}
      />
    </div>
  );
};

export default HCLogo;
